(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orvi-daily-renew-cream"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.orvi-cream').forEach(root=>{const i=root.querySelector('input[name="quantity"]'),m=root.querySelector('[data-minus]'),p=root.querySelector('[data-plus]');if(i&&m&&p){m.addEventListener('click',()=>i.value=Math.max(1,(parseInt(i.value,10)||1)-1));p.addEventListener('click',()=>i.value=(parseInt(i.value,10)||1)+1)}})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orvi-radiant-serum"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.orvi-radiant').forEach((root)=>{const input=root.querySelector('#orvi-radiant-qty');const minus=root.querySelector('[data-minus]');const plus=root.querySelector('[data-plus]');if(input&&minus&&plus){minus.addEventListener('click',()=>{input.value=Math.max(1,(parseInt(input.value,10)||1)-1)});plus.addEventListener('click',()=>{input.value=(parseInt(input.value,10)||1)+1})}})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orvi-sun-defense"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.orvi-spf').forEach(root=>{const i=root.querySelector('input[name="quantity"]'),m=root.querySelector('[data-minus]'),p=root.querySelector('[data-plus]');if(i&&m&&p){m.addEventListener('click',()=>i.value=Math.max(1,(parseInt(i.value,10)||1)-1));p.addEventListener('click',()=>i.value=(parseInt(i.value,10)||1)+1)}})

  } catch(e) { console.error(e); }
})();
})();
